import React, {Component} from 'react';

import {
    Row,
} from 'reactstrap';

import VehicleForm from "./forms/VehicleForm";

class VehicleFrame extends Component {

    render() {
        return (
            <div>
                <Row>
                    <h3>Vehicle Information</h3>
                </Row>
                <hr/>

                <VehicleForm/>

            </div>
        );
    }
}

export default VehicleFrame;


// WEBPACK FOOTER //
// ./src/containers/tenant/application/frames/VehicleFrame.js